import React, {useEffect} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {withTranslation} from 'react-i18next'
import {Drawer, Row, Col} from 'antd'
import {ShoppingCartOutlined} from '@ant-design/icons'

import useCartContext from 'components/Cart/useCartContext'
import BButton from 'components/Form/Fields/BButton'
import priceParser from 'utils/priceParser'

const tmpPrice = 14449.90

const CartDrawer = ({history, t}) => {
  const {cart, cartDispatch, cartVisible, setCartVisible} = useCartContext()

  useEffect(() => {
    history.listen(() => setCartVisible(false))
  }, [history, setCartVisible])

  const cartRemove = (event, uuid) => {
    event.preventDefault()
    cartDispatch({type: 'remove', payload: uuid})
  }

  return (
    <Drawer
      className='cartDrawer'
      onClose={() => setCartVisible(false)}
      visible={cartVisible}
      width={400}
      title={<div><ShoppingCartOutlined/> {t('Your cart')}</div>}
      footer={
        <div className='cartDrawer-footer'>
          <Row>
            <Col span={12}>
              <b>{t('Order total')}</b>
            </Col>
            <Col span={12}>
              <b>{priceParser(tmpPrice)}</b>
              <span>{t('Inc. VAT')}</span>
            </Col>
          </Row>
          <Link to='/checkout'><BButton yellow>{t('CONTINUE TO CHECKOUT')}</BButton></Link>
        </div>
      }
    >
      {Object.keys(cart.items).map(e => (
        <div key={e}>
          {cart.items[e].count} x <Link to={`/product/${e}`}><b>{cart.items[e].data.name}</b></Link> <b>{cart.items[e].price}</b> <button onClick={event => cartRemove(event, e)}>remove</button>
        </div>
      ))}
      {Object.keys(cart.items).length <= 0 && 'Cart is empty'}
    </Drawer>
  )
}

export default withRouter(withTranslation()(CartDrawer))
